import { ISvgProps, Svg } from '@components';
import { memo } from 'react';

export const DocumentIcon = memo<ISvgProps>((props, { className }) => (
  <Svg className={className} width="22.719" height="30.292" viewBox="0 0 22.719 30.291" {...props}>
    <g id="fi-rr-document-signed" transform="translate(-3 0)">
      <path
        id="Path_22027"
        data-name="Path 22027"
        d="M23.87,3.94,21.78,1.848A6.27,6.27,0,0,0,17.317,0H9.311A6.318,6.318,0,0,0,3,6.311v17.67a6.318,6.318,0,0,0,6.311,6.311h10.1a6.318,6.318,0,0,0,6.311-6.311V8.4A6.27,6.27,0,0,0,23.87,3.94ZM22.085,5.725a3.7,3.7,0,0,1,.478.586H19.408V3.155a3.913,3.913,0,0,1,.587.48Zm1.109,18.256a3.786,3.786,0,0,1-3.786,3.786H9.311a3.786,3.786,0,0,1-3.786-3.786V6.311A3.786,3.786,0,0,1,9.311,2.524h7.573V6.311a2.524,2.524,0,0,0,2.524,2.524h3.786ZM19.408,11.359a1.262,1.262,0,1,1,0,2.524H9.311a1.262,1.262,0,1,1,0-2.524ZM20.67,17.67a1.262,1.262,0,0,1-1.262,1.262H9.311a1.262,1.262,0,1,1,0-2.524h10.1A1.262,1.262,0,0,1,20.67,17.67Zm-.242,4.308a1.262,1.262,0,0,1-.274,1.759,8.159,8.159,0,0,1-4.362,1.506,4.1,4.1,0,0,1-2.524-.884c-.414-.284-.572-.379-.884-.379a4.987,4.987,0,0,0-2.312,1,1.262,1.262,0,0,1-1.532-2,7.4,7.4,0,0,1,3.85-1.522,3.818,3.818,0,0,1,2.312.827,1.7,1.7,0,0,0,1.091.435A5.788,5.788,0,0,0,18.666,21.7,1.262,1.262,0,0,1,20.428,21.978Z"
        transform="translate(0)"
        fill="#3477eb"
      />
    </g>
  </Svg>
));

DocumentIcon.displayName = 'DocumentIcon';

export default DocumentIcon;
